import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';
import saveAs from 'file-saver';
import { useNavigate } from 'react-router-dom'
//var dateFormat = require('dateformat');

	

const RenderWpForm = () => {

const resturl=sessionStorage.getItem("RESTURL");
let customspremurl='https://customsprem.gov.tc/';
//var boolFetchingSads=false;

const navigate = useNavigate();



const [pastmonths, setPastmonths] = useState([]);
const [finyropts, setFinyropts] = useState([]);
const [tcislands, setTcislands] = useState([]);
const [arrisland, setArrisland] = useState([]);


const [crit, setCrit] = useState({date1:"", date2:"", processarea:"", rpt_type:""});
const [dlwait, setDlwait] = useState({show:false});
const [dowaitlog, setDowaitlog] = useState({show:false});
const [tblreportrunlog, setTblreportrunlog] = useState([]);


const startupSecs='30';//here on test page this will be 10 seconds
let numticks=0;
const [countdown, setCountdown] = useState({sec:startupSecs});
const [ticks, setTicks] = useState({num:0});

let reloadTimer=null;
//var currmins=10;
const timerEvent = () => {
	numticks+=1;
	const newticks=numticks;
	//console.log('numticks:'+numticks);
	//console.log('newticks:'+newticks);
	setTicks({num:newticks});
};


const location = useLocation();
const AD_USER=sessionStorage.getItem("AD_USER")?sessionStorage.getItem("AD_USER"):"";

useEffect(() => {

const USERNAME = sessionStorage.getItem("USERNAME")??"";
	
if (USERNAME==""){
	navigate("/");
	return;
	}//end if

if (AD_USER==""){
	navigate("/dashboard");
	return;
	}//end if	
	
document.title =   "APS Reports";	

if (reloadTimer==null)
	reloadTimer = setInterval(timerEvent, 1000);//*60
else{

	}//end else


getvwfinyr();

//getpastmonths();
// Stops the old timer when umount the component.
return function stopTimer() {
	  console.log("cleaning up");
  clearInterval(reloadTimer);
}
 },[]);


useEffect(() => {

if (countdown.sec=='00'){
	gettblreportrunlog();
	setDlwait({show:false});
	}//end if
	
	
//console.log("ticks.num: "+ticks.num);
	if (countdown.sec=='01')
		setCountdown({sec:'00'});
	else{
		const newsec=countdown.sec=='00'?30:(1*countdown.sec)-1;
		const padd=newsec<10?"0":"";
		setCountdown({sec:padd+newsec});
		}

 },[ticks.num]);

useEffect(() => {

if (tcislands.length==0)
	return;

if (!document.getElementsByName("cbisland[]")[0])
	return;

if (document.getElementsByName("cbisland[]").length!=tcislands.length)
	return;

/*
for (var i=0; i<tcislands.length; i++){
	document.getElementsByName("cbisland[]")[i].checked=true;
	}
*/
document.getElementById("cball").checked=true;
checkAllBoxes({target:{checked:true}})

 },[JSON.stringify(tcislands)]);



useEffect(() => {

console.log("arrisland: "+JSON.stringify( arrisland ));	
if (arrisland.length>0 && tcislands.length==0)
	writeTcislands();

 },[JSON.stringify(arrisland)]);


useEffect(() => {

if (tblreportrunlog.length>0)
	setCountdown({sec:startupSecs});;

 },[JSON.stringify(tblreportrunlog)]);
 
 
useEffect(() => {

if (pastmonths.length>0)
	gettblreportrunlog();

 },[JSON.stringify(pastmonths)]);

useEffect(() => {

if (finyropts.length>0 && pastmonths.length==0)
	getpastmonths();

 },[JSON.stringify(finyropts)]);


useEffect(() => {

if (pastmonths.length>0 && tcislands.length==0)
	gettcislands()

 },[JSON.stringify(pastmonths)]);



useEffect(() => {

if (tcislands.length>0 && crit.date1=="")
	getlastmonthdates();

 },[JSON.stringify(tcislands)]);



useEffect(() => {

if (crit.rpt_type!="")
	document.getElementById("btnsubmit").click();
	
	//document.forms.form1.submit();
	//getxlfilename();


 },[crit.rpt_type]);



function rptChange(e, rpt_type){
	
	e.preventDefault();
	
	console.log("rptChange: "+rpt_type);
	
	if (rpt_type==crit.rpt_type)
		document.getElementById("btnsubmit").click();
	else
		setCrit((prev)=>{
			return {...prev, rpt_type:rpt_type}
		});
	
}//end func

async function getxlfilename(e){
	
	e.preventDefault();
	
	console.log("getxlfilename: "+crit.rpt_type);
	   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {} )
  };	
  
  await  fetch(resturl+'rarxlreport/getxlfilename',requestOptions)
      .then(res => res.json())
      .then(res => 	{
		  if (crit.rpt_type=="lc")
			  callrptlbrclrmonth(res, e);
		  else if (crit.rpt_type=="wp")
			  callrptwrkpmtmonth(res, e);
		  else if (crit.rpt_type=="wtm")
			  callrptapswaittime(res, e);
		  }  )
      .catch(err => console.log(err));	
}//end func




async function callrptapswaittime(res, e){

let FILE_NAME="default_file_name";
const prefix=crit.rpt_type=="wtm"?"APS_Wait_Times_":"Labour_Clearance_";
if (res.length)
	FILE_NAME=prefix+res[0].FILE_NAME;

let lsisland="";
for (var i=0; i<arrisland.length; i++){
	if (arrisland[i].checked==true){
		if (lsisland!="")
			lsisland+=",";
		
		lsisland+=arrisland[i].id;
		}//end if
	}//end for
console.log("arrisland: "+JSON.stringify( arrisland ));	

const params={
	
	FILE_NAME: FILE_NAME
	, USERNAME:sessionStorage.getItem("USERNAME")
	, DATE1:crit.date1
	, DATE2:crit.date2
	, processarea: crit.processarea
	, CRIT:""
	, lsisland:lsisland
};

console.log("params: "+JSON.stringify( params ));

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

setDlwait({show:true});
			setCrit((prev)=>{
		return {...prev
			, processarea:""
			}
		});


 await fetch(resturl+'rarxlreport/rptapswaittime',requestOptions)
      .then(res => res.json())
	  .then(res => 	aftercallrptapswaittime(res, e) )
      .catch(err => console.log(err));


}//end func


async function aftercallrptapswaittime(res, e){

setDlwait({show:false});

const UPDATE_COUNT=res.length?(res[0].UPDATE_COUNT??0):0;

if (UPDATE_COUNT>0){
	showsnackbar("the table will reload when the report is done");
	gettblreportrunlog();
	}
else
	showsnackbar("something went wrong.  try again or contact admin");
	
}//end func




async function callrptlbrclrmonth(res, e){

let FILE_NAME="default_file_name";
const prefix=crit.rpt_type=="wp"?"Work_Permit_":"Labour_Clearance_";
if (res.length)
	FILE_NAME=prefix+res[0].FILE_NAME;

let lsisland="";
for (var i=0; i<arrisland.length; i++){
	if (arrisland[i].checked==true){
		if (lsisland!="")
			lsisland+=",";
		
		lsisland+=arrisland[i].id;
		}//end if
	}//end for
console.log("arrisland: "+JSON.stringify( arrisland ));	

const params={
	
	FILE_NAME: FILE_NAME
	, USERNAME:sessionStorage.getItem("USERNAME")
	, DATE1:crit.date1
	, DATE2:crit.date2
	, processarea: crit.processarea
	, CRIT:""
	, lsisland:lsisland
};

console.log("params: "+JSON.stringify( params ));

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

setDlwait({show:true});
			setCrit((prev)=>{
		return {...prev
			, processarea:""
			}
		});


 await fetch(resturl+'rarxlreport/rptlbrclrmonth',requestOptions)
      .then(res => res.json())
	  .then(res => 	aftercallrptlbrclrmonth(res, e) )
      .catch(err => console.log(err));


}//end func


async function aftercallrptlbrclrmonth(res, e){

setDlwait({show:false});

const UPDATE_COUNT=res.length?(res[0].UPDATE_COUNT??0):0;

if (UPDATE_COUNT>0){
	showsnackbar("the table will reload when the report is done");
	gettblreportrunlog();
	}
else
	showsnackbar("something went wrong.  try again or contact admin");
	
}//end func


function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func

async function callrptlbclrgndrtype(res, e){

let FILE_NAME="default_file_name";
if (res.length)
	FILE_NAME="Work_Permit_"+res[0].FILE_NAME;

let lsisland="";
for (var i=0; i<arrisland.length; i++){
	if (i>0)
		lsisland+=",";
	lsisland+=arrisland[i].id;
	}
	

const params={
	
	FILE_NAME: FILE_NAME
	, USERNAME:sessionStorage.getItem("USERNAME")
	, DATE1:crit.date1
	, DATE2:crit.date2
	, processarea: crit.processarea
	, CRIT:""
	, lsisland:lsisland
};

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

/*
if (!e.target.classList.contains("hidden"))
	e.target.classList.add("hidden");
*/
setDlwait({show:true});

 await fetch(resturl+'rarxlreport/rptlbclrgndrtype',requestOptions)
      .then(res => 	aftercallrptlbclrgndrtype(res, e, FILE_NAME) )
      .catch(err => console.log(err));

}//end func


async function aftercallrptlbclrgndrtype(res, e, FILE_NAME){

setDlwait({show:false});
	
/*if (e.target.classList.contains("hidden"))
	e.target.classList.remove("hidden");
	*/
	const blob = await res.blob();
	saveAs(blob, FILE_NAME+".xlsx");
			setCrit((prev)=>{
		return {...prev, rpt_type:""}
	});
	
}//end func



async function callrptwrkpmtmonth(res, e){

let FILE_NAME="default_file_name";
if (res.length)
	FILE_NAME="Work_Permit_"+res[0].FILE_NAME;

let lsisland="";
for (var i=0; i<arrisland.length; i++){
	if (i>0)
		lsisland+=",";
	lsisland+=arrisland[i].id;
	}
	

const params={
	
	FILE_NAME: FILE_NAME
	, USERNAME:sessionStorage.getItem("USERNAME")
	, DATE1:crit.date1
	, DATE2:crit.date2
	, processarea: crit.processarea
	, CRIT:""
	, lsisland:lsisland
};

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

/*
if (!e.target.classList.contains("hidden"))
	e.target.classList.add("hidden");
*/
setDlwait({show:true});

 await fetch(resturl+'rarxlreport/rptapprovedwpxl',requestOptions)
      .then(res => 	aftercallrptwrkpmtmonth(res, e, FILE_NAME) )
      .catch(err => console.log(err));

}//end func


async function aftercallrptwrkpmtmonth(res, e, FILE_NAME){

setDlwait({show:false});
	
/*if (e.target.classList.contains("hidden"))
	e.target.classList.remove("hidden");
	*/
	const blob = await res.blob();
	saveAs(blob, FILE_NAME+".xlsx");
			setCrit((prev)=>{
		return {...prev, rpt_type:""}
	});
	
}//end func

function clickIsland(e){

const {checked, value}=e.target;

//console.log("clickIsland checked: "+checked);
//console.log("clickIsland value: "+value);
//var intchecked=(checked==true)?1:0;
//console.log("clickIsland checked: "+intchecked);

let temp=arrisland;
//console.log("temp: "+JSON.stringify(temp));

for (var i=0; i<arrisland.length; i++)	{
	if (arrisland[i].id == value)
		arrisland[i].checked = checked;
	}//end for	

//console.log("temp: "+JSON.stringify(temp));

setArrisland((prev)=>{
	return [...temp]
	});
	
}//end func

function handleChange(e){

const {name, value} = e.target;

console.log("handleChange "+name);
console.log("handleChange "+value);

setCrit((prev)=>{
	return {...prev, [name]:value}
	});

	
}//end func

async function getpastmonths(){

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {} )
  };		

 await fetch(resturl+'rarxlreport/getpastmonths',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetpastmonths(res) )
      .catch(err => console.log(err));

}//end func



function aftergetpastmonths(res){

let tempopts=[];
res.map((col, index) => {
	const key="yrmm_"+index;
		tempopts.push(<option key={key} value={col['YRMM']}  >{col['MNTH']}</option>);
	});//end map

setPastmonths(tempopts);	
	
}//end func	
	


async function getvwfinyr(){

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {} )
  };		

 await fetch(resturl+'rarxlreport/getvwfinyr',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetvwfinyr(res) )
      .catch(err => console.log(err));

}//end func



function aftergetvwfinyr(res){

let tempopts=[];
res.map((col, index) => {
	const key="finyr_"+index;
		tempopts.push(<option key={key} value={col['YEARNAME']}  >{col['YEARNAME']}</option>);
	});//end map

setFinyropts(tempopts);	
	
}//end func	


async function gettblreportrunlog(){

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {USERNAME:sessionStorage.getItem("USERNAME")} )
  };		

	setDowaitlog({show:true});

 await fetch(resturl+'rarxlreport/gettblreportrunlog',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergettblreportrunlog(res) )
      .catch(err => console.log(err));

}//end func

async function aftergettblreportrunlog(res){
	
	setDowaitlog({show:false});
	
	if (!res.length)
		return;
	
	let htmrows=[];
	
	res.map((col, index) => {
	const rptid=col['REPORT_RUN_ID'];
	const trkey='tr_'+rptid;
	const DONE=col['DONE']??"";
	
	const htmrow=<tr key={trkey} >
	<td align='right' >{index+1}</td>
	<td align='center' >{col['STAMP']}</td>
	<td align='center' >&nbsp;<a href="#" className="nodecor" onClick={(e)=>{downloadreport(e, col['FILE_PATH'], col['LONG_NAME'], DONE);}} ><img src="img/msexcel.gif" border='0' />&nbsp;{col['LONG_NAME']}</a></td>
	<td align='center' >{col['DONE']}</td>
	<td align='center' >{col['ERROR_MSG']}</td>
	</tr>;
	
	htmrows.push(htmrow);
	});
	
setTblreportrunlog(htmrows);
	
}//end func


async function downloadreport(e, FILE_PATH, FILE_NAME, DONE){
	e.preventDefault();
/*
	if (!e.target.classList.contains("hidden"))
		e.target.classList.add("hidden");

*/
	if (DONE==""){
		window.alert("please wait until the table shows the report is done");
		return;
		}
	
	   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {FILE_PATH:FILE_PATH} )
  };	
  
  setDowaitlog({show:true});
  
	 await fetch(resturl+'rarxlreport/downloadreport',requestOptions)
      .then(res => 	afterdownloadreport(res, e, FILE_NAME) )
      .catch(err => console.log(err));

}//end func

async function afterdownloadreport(res, e, FILE_NAME){
setDowaitlog({show:false});	


	const blob = await res.blob();
	saveAs(blob, FILE_NAME+".xlsx");
			setCrit((prev)=>{
		return {...prev, rpt_type:""}
	});

}//end func



async function aftercallrptwrkpmtmonth(res, e, FILE_NAME){

setDlwait({show:false});
	
/*if (e.target.classList.contains("hidden"))
	e.target.classList.remove("hidden");
	*/
	const blob = await res.blob();
	saveAs(blob, FILE_NAME+".xlsx");
			setCrit((prev)=>{
		return {...prev, rpt_type:""}
	});
	
}//end func

async function getlastmonthdates(){

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {} )
  };		

	
 await fetch(resturl+'rarxlreport/getlastmonthdates',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetlastmonthdates(res) )
      .catch(err => console.log(err));

}//end func


function aftergetlastmonthdates(res){

let date1="";

if (res.length)
	date1=res[0].DATE1??"";

if (date1=="")
	console.log("aftergetlastmonthdates received no date1");
else{
	setCrit((prev)=>{
		return {...prev
			, date1:date1
			, date2:res[0].DATE2
			}
		});
	}//end if
	
}//end func



async function gettcislands(){

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {} )
  };		

 await fetch(resturl+'rarxlreport/gettcislands',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergettcislands(res) )
      .catch(err => console.log(err));

}//end func



function aftergettcislands(res){

let temparrisland=[];
res.map((col, index) => {
	const key="tcisl_"+index;
	
	const islandid=col['LOCATIONID'];
	
	if (islandid>0)
		temparrisland.push({
			id:col['LOCATIONID']
			, location:col['LOCATION']
			, checked: true
			});
	});//end map

setArrisland(temparrisland);

}//end func		

function writeTcislands(){
	
	let htmrows=[];
	
	for (var i=0; i<arrisland.length; i++){
		const key = "cbisland_"+i;
		htmrows.push(
				<tr key={key}   >
				<td align="left" ><input type="checkbox" name="cbisland[]" required value={arrisland[i].id} id={key} onClick={(e)=>{clickIsland(e);}} /><label htmlFor={key} className="hand" >{arrisland[i].location}</label></td>
				</tr>
				
				);
		
		}//end for
	setTcislands(htmrows);
}//end if

function checkAllBoxes(e){
console.log("checkAllBoxes: "+e.target.checked);
let cbisland=document.getElementsByName("cbisland[]");

console.log("cbisland.length: "+cbisland.length);
let temparrisland=arrisland;
for	(var i=0; i<cbisland.length; i++){
	cbisland[i].checked=e.target.checked;
	temparrisland[i].checked = cbisland[i].checked;
	}//end for
	
setArrisland(temparrisland);	
	
}//end func		


{
/*
			<select onChange={(e)=>{getxlfilename(e, "rptwrkpmtmonth");}} style={{textAlign:"center"}} title="generate work permit report for selected fin. year" >
			<option value='' >* * * select financial year * * *</option>
			{finyropts}
			</select>

*/	
	
}	

  return (
    <>
	<p align="center" className="Acme" style={{marginBottom:"6px", marginTop:"9px", color:"brown",fontSize:"24px"}} >Reports</p>

<table align="center" border="0" >
<tbody>
<tr valign="top" >
<td>
	<form method="post" id="form1" onSubmit={(e)=>{getxlfilename(e);}}  >
	{dlwait.show && <span><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</span>}
	{!dlwait.show && 
	<table align="center" style={{marginTop:"12px"}} >	
	<tbody>

	<tr>
		<td align="right" >Coporate/General:</td>
		<td align="left" >
			<select name="processarea" value={crit.processarea} onChange={(e)=>{handleChange(e);}} required >
			<option value='' ></option>
			<option value='Corporate' >Corporate</option>
			<option value='General' >General</option>
			</select>&nbsp;
			<input size="2" type="hidden" readOnly className="gnsbro" value={crit.rpt_type} />
		</td>
	</tr>
	<tr>
		<td align="right" >From Date:</td>
		<td align="left" ><input name="date1" value={crit.date1} onChange={(e)=>{handleChange(e);}} required type="date" /></td>
	</tr>
	<tr>
		<td align="right" >To Date:</td>
		<td align="left" style={{paddingBottom:"12px"}} ><input name="date2" value={crit.date2} onChange={(e)=>{handleChange(e);}} required type="date" /></td>
	</tr>
	<tr>
		<td>&nbsp;</td>
		<td align="left" style={{paddingBottom:"12px"}} >
		<a href="#" className="nodecor" onClick={(e)=>{rptChange(e,"lc");}} ><img src="img/msexcel.gif" border="0" /> Labour Clearance report</a>
		</td>
	</tr>
	<tr>
		<td>&nbsp;</td>
		<td align="left"style={{paddingBottom:"12px"}}  >
		<a href="#" className="nodecor" onClick={(e)=>{rptChange(e,"wp");}} ><img src="img/msexcel.gif" border="0" /> Work Permit report</a>
		</td>
	</tr>
	<tr>
		<td>&nbsp;</td>
		<td align="left"style={{paddingBottom:"12px"}}  >
		<a href="#" className="nodecor" onClick={(e)=>{rptChange(e,"wtm");}} ><img src="img/msexcel.gif" border="0" /> Wait Times report</a>
		<input type="image" src="img/transparent.png" id="btnsubmit" />
		</td>
	</tr>
	</tbody>
	</table>
	}
	</form>

</td>
<td align="center" width="40" >&nbsp;</td>
<td>
	<table align="center" style={{marginTop:"18px"}} >	
	<tbody>
	<tr><th className="gnsbro" ><input type="checkbox" id="cball" onClick={(e)=>{checkAllBoxes(e);} }  /><label htmlFor="cball" className="hand" >check/uncheck all</label></th></tr>
	{tcislands}
	</tbody>
	</table>

</td>
</tr>
</tbody>
</table>

<p align="center" >table of history reports.  will reload after {countdown.sec} seconds</p>
<table align="center" className="customers" style={{width:"55%"}} >
<thead>
<tr>
	<th>#</th>
	<th>Date</th>
	<th>Click the Report File Name below to download</th>
	<th>Done</th>
	<th>Error</th>
</tr>
</thead>
<tbody>
{dowaitlog.show==true && <><tr><td colSpan="5" ><span><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</span></td></tr></>}
{dowaitlog.show==false && tblreportrunlog}
</tbody>
</table>

<div id="snackbar">&nbsp;</div>


<div className="modalsm">
    <div className="modalsm-content">
        <span className="close-button"  >&times;</span>
        <div align='center' id='modalsmtext' >
			
		</div>
    </div>
</div>
<div id="snackbar">&nbsp;</div>


    </>
  );
  


};


export default RenderWpForm;